export const useCustomFormErrors = () => {
  const customError = ref({});

  function setCustomError(formErrors: any, errorWrapperClass: string = '.customError__Wrapper') {
    if (!formErrors) return;
    if (formErrors.field_errors) {
      const fieldErrors = formErrors.field_errors;
      for (let error in fieldErrors) {
        fieldErrors[error] = { code: fieldErrors[error] }
      }
    }

    if (formErrors.error_code) {
      const element = document.querySelector(errorWrapperClass);
      customError.value = { code: formErrors.error_code };
      if (element) element.scrollIntoView({ behavior: 'smooth' })
      else window.scrollTo(0, 0);
    }
  }

  return {
    customError,
    setCustomError,
  }
}